import { mapState } from 'vuex';
import multiSearchMixin from '@/mixins/multiSearchVirtualDevices';
import { validImageFileName } from '@/utils/vuex';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
import 'codemirror/mode/markdown/markdown.js';
export default {
  name: 'CoreVirtualDeviceSmartGroupsMetaEdit',
  components: {
    MarkdownItVueLight
  },
  mixins: [multiSearchMixin],
  props: {
    smartGroup: {
      type: Object,
      default: () => ({})
    }
  },
  data: function () {
    return {
      editModel: null,
      markdownEdit: false,
      valid: false
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    saveDisabled() {
      return !this.selectedAccount || !this.viewTitle || !this.searchItems.length;
    },
    filteredSearchTypes() {
      return this.searchTypes.filter(type => type.param !== 'health' && type.param !== 'zone');
    },
    selectedAttachments() {
      if (this.editModel.meta && this.editModel.meta.viewImageId) {
        return [this.editModel.meta.viewImageId];
      }
      return [];
    },
    viewImages() {
      return [{
        name: this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.none'),
        id: null
      }].concat((this.editModel.meta && this.editModel.meta.attachments || []).filter(attachment => {
        return validImageFileName(attachment.name);
      }));
    },
    packetMonitoringInterval() {
      return [{
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.timeRange.items.LAST_HOUR'),
        value: 60
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.timeRange.items.LAST_DAY'),
        value: 1440
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.timeRange.items.LAST_WEEK'),
        value: 10080
      }];
    },
    requiredRule() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired')];
    }
  },
  watch: {
    smartGroup: {
      handler: function () {
        this.initEditItem(cloneDeep(this.smartGroup));
      },
      deep: true,
      immediate: true
    },
    editModel: {
      handler: function () {
        // only publish changes if an actual value did change, not just a new cloned instance got assigned
        if (JSON.stringify(this.editModel) !== JSON.stringify(this.smartGroup)) {
          this.publishChanges();
        }
      },
      deep: true
    }
  },
  methods: {
    async initEditItem(smartGroup) {
      if (smartGroup) {
        this.editModel = cloneDeep({
          ...smartGroup,
          meta: {
            ...(get(smartGroup, 'meta') || {}),
            monitoring: {
              ...(get(smartGroup, 'meta.monitoring') || {
                threshold: 3000,
                interval: 60,
                type: 'warning'
              })
            }
          }
        });
      }
      const searchOperator = get(this.editModel, 'viewConfig.searchOperator', 'AND');
      const searchItems = get(this.editModel, 'viewConfig.searchItems', []);
      this.searchItems = searchItems.map(item => ({
        param: item.variable,
        search: item.search
      }));
      this.searchOperator = searchOperator;
    },
    searchUpdated(searchItems, operator) {
      this.searchItems = searchItems; // defined in multiSearchMixin
      this.searchOperator = operator; // defined in multiSearchMixin
    },
    attachmentsUpdated(data) {
      if (!this.editModel.meta) {
        this.editModel.meta = {};
      }
      this.editModel.meta.attachments = data;
    },
    viewImageSelected(item) {
      if (!this.editModel.meta) {
        this.editModel.meta = {};
      }
      this.editModel.meta.viewImageId = item.id;
    },
    viewImageDeselected() {
      if (!this.editModel.meta) {
        this.editModel.meta = {};
      }
      delete this.editModel.meta.viewImageId;
    },
    createRequestOptions() {
      return {
        ...this.editModel,
        // meta: null, // meta is included in the docs, but API throws 400 when used
        viewConfig: {
          searchItems: this.searchItems.map(item => ({
            variable: item.param,
            // support item.search.value === null, so do not simply have a >search.value || search< expression
            search: (item.search || {}).value === undefined ? item.search : item.search.value
          })),
          searchOperator: this.searchOperator,
          filters: [{
            type: 'tenantIds',
            ids: [this.editModel.tenantId]
          }],
          options: null
        }
      };
    },
    save() {
      const params = this.createRequestOptions();
      this.$emit('save', params);
    },
    publishChanges: debounce(function () {
      this.$emit('change', this.editModel);
    }, 250)
  }
};